import { effect, inject, Injectable, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LocalStorageKeys, LocalStorageService } from '../data/local-storage.service';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly #document = inject(DOCUMENT);
  readonly #localStorageService = inject(LocalStorageService);

  readonly isDark = signal<boolean>(this.#document.documentElement.classList.contains('dark'));

  public constructor() {
    effect(() => {
      const isDark = this.isDark();
      if (isDark) {
        this.#document.documentElement.classList.add('dark');
        this.#localStorageService.set(LocalStorageKeys.darkMode, 'dark');
      } else {
        this.#document.documentElement.classList.remove('dark');
        this.#localStorageService.set(LocalStorageKeys.darkMode, 'light');
      }
    });
  }
}
